import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import messages from "../../../assets/locale/messages";
import RejectReasonModal from "../../modals/RejectReasonModal";
import RequestSummary from "../RequestSummary";

/** Rejects a publishing or crew size change request with a mandatory reason. */
const RejectRequestModal = ({ request, onClose, onConfirm }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { publishingRequests: t, shared } = messages[lang];

  return (
    <RejectReasonModal
      open={Boolean(request)}
      onClose={onClose}
      onConfirm={(reason) => onConfirm(request, reason)}
      title={request ? t[request.type].rejectTitle : ""}
      description={t.rejectDescription}
      details={
        request && (
          <RequestSummary
            request={request}
            amountLabel={t.summary.amountDue}
            emphasizeAmount
          />
        )
      }
      reasonLabel={t.rejectionReason}
      reasonPlaceholder={t.rejectionReasonPlaceholder}
      confirmLabel={t.reject}
      cancelLabel={shared.cancel}
      requiredErrorMessage={t.rejectionReasonRequired}
      modalClassName="publishing-request-modal publishing-request-reject-modal"
      reasonInputId="publishing-request-rejection-reason"
    />
  );
};

RejectRequestModal.propTypes = {
  /** The request to reject; null keeps the popup closed. */
  request: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  /** Called with the request and the trimmed reason. */
  onConfirm: PropTypes.func.isRequired,
};

RejectRequestModal.defaultProps = {
  request: null,
};

export default RejectRequestModal;
